import { Component, OnInit } from '@angular/core';
import { MainserviceService } from './../mainservice.service';
import { ActivatedRoute, ParamMap } from "@angular/router";

@Component({
  selector: 'app-games',
  templateUrl: './games.component.html',
  styleUrls: ['./games.component.scss']
})
export class GamesComponent implements OnInit {
 
  games:any;

  stats:any;

  promos:any;

  allUsers:number;
  activeUsers:number;

  constructor(private mainServ: MainserviceService) { }

  ngOnInit() {

    this.getgames();
    this.getUsers();
    this.getActiveUsers();

  }

  getgames() {
    this.mainServ.getGames().subscribe(data => {
        this.games = data
        for(var i in data){
          var theGames = data[i]
        }
        this.mainServ.getGameStats(theGames.id).subscribe( gameData=>{
          this.stats = gameData[0]
        this.mainServ.getGamePromocodes(theGames.id).subscribe( gamePromo =>{
          this.promos =gamePromo[0]
        })  
        })
    });
  } 

  getUsers(){
    this.mainServ.getUsers().subscribe(data => 
      {this.allUsers = data.length })
  }
  getActiveUsers(){
    this.mainServ.getStatistics("plays", "users").subscribe(data =>{
      this.activeUsers =data.length

    })
  }


}



// WEBPACK FOOTER //
// D:/PROJECTS/Sokousoni/winda-dashboard/dashboard-winda-mvp/src/app/games/games.component.ts